<template>
	<a class="linkServices" :href="navLinks.admin">
		<div class="frame"></div>
		<span class="text">Admin</span>
	</a>
</template>

<script>
export default {
	name: 'admin-template',
	data () {
		return {
			navLinks: {}
		}
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug(`navLinks is `, this.navLinks)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/adminButton.vue